import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { StoreLoader, Unsubscriber } from '@core-lib/classes';
import { UnarchiveFilter } from '@core-lib/enums';
import { IReleveOperationsRequestDto, IUnarchiveAffairesRequest } from '@core-lib/models';
import { AffaireSharedService } from '@core-lib/services';
import { ModalRef } from '@core-lib/modules/modal-container';
import { Subject, first, of } from 'rxjs';

@Component({
	selector: 'unarchive-affaires-modal',
	templateUrl: './unarchive-affaires-modal.component.html',
	standalone: false
})
export class UnarchiveAffaireModalComponent extends Unsubscriber implements OnInit {
	@Input() affaireIds: string[];
	@Input() count: number;
	@Output() onUnarchived: EventEmitter<string[]> = new EventEmitter<string[]>();

	@Input() toutesAffaires: boolean = false;
	@Input() filterModel: any;

	selectedFilter: any = '';
	form: UntypedFormGroup;
	generateReleveModalRef: ModalRef;

	loader: StoreLoader = new StoreLoader(of(false), of(null));
	loaderSubject = new Subject<StoreLoader>();
	loader$ = this.loaderSubject.asObservable();

	unarchiveFilter = Object.entries(UnarchiveFilter).map(value => ({
		key: value[0],
		value: value[1]
	}));

	constructor(
		public modalRef: ModalRef,
		private affaireSharedService: AffaireSharedService
	) {
		super();
		this.loader$.subscribe(res => (this.loader = res));
	}

	ngOnInit(): void {
		this.initForm();
	}

	initForm() {
		this.form = new UntypedFormGroup({
			selectedOption: new UntypedFormControl(this.getKeyFromValue(this.unarchiveFilter, UnarchiveFilter.Non))
		});
	}

	onClose(): void {
		this.modalRef.hide();
	}
	onUnarchive(): void {
		this.selectedFilter = this.form.controls['selectedOption'].value;
		const request: IUnarchiveAffairesRequest = {
			affaireIds: this.affaireIds,
			toutesAffaires: this.toutesAffaires,
			filtresAffaires: this.filterModel
		};
		this.loaderSubject.next(new StoreLoader(of(true), of(null)));
		this.affaireSharedService.unarchiveAffaires(request).subscribe({
			next: result => {
				this.loaderSubject.next(new StoreLoader(of(false), of(null)));
				const requestExportCSv: IUnarchiveAffairesRequest = {
					affaireIds: result
				};

				switch (this.selectedFilter) {
					case this.getKeyFromValue(this.unarchiveFilter, UnarchiveFilter.OuiCsv): {
						this.loaderSubject.next(new StoreLoader(of(true), of(null)));
						this.affaireSharedService.exportUnarchiveAffaires(requestExportCSv).subscribe({
							next: () => {
								this.loaderSubject.next(new StoreLoader(of(false), of(null)));
							},
							error: e => {}
						});
						break;
					}
					case this.getKeyFromValue(this.unarchiveFilter, UnarchiveFilter.OuiPdf): {
						this.generateReleve(result);
						break;
					}
				}
				this.onUnarchived.next(this.affaireIds);
			},
			error: e => {}
		});
	}

	generateReleve(affaireIds: string[]): void {
		if (this.affaireIds?.length > 0) {
			// Ouvre une fenêtre immédiatement (non bloquée)
			const newWindow = window.open('', '_blank');

			const releveOperationsRequestDto: IReleveOperationsRequestDto = {
				affaireIds: this.affaireIds,
				filtresAffaires: this.filterModel
			};

			this.affaireSharedService
				.getOperationReleveOtt(releveOperationsRequestDto)
				.pipe(first())
				.subscribe(resp => {
					if (resp.ott && newWindow) {
						newWindow.location.href = this.affaireSharedService.getOperationRelevePdf(resp.ott);
					} else {
						newWindow?.close(); // Ferme la fenêtre si erreur
					}
					this.onClose();
				});
		}
	}

	public buildInputId(name: string): string {
		return name.replace(/\s/g, '').toLocaleLowerCase();
	}

	getKeyFromValue(enumObject: any, value: string): string | undefined {
		for (const key in enumObject) {
			if (enumObject[key].value === value) {
				return enumObject[key].key;
			}
		}
		return undefined; // Value not found in the enum
	}
}
